import Sidebar from '../components/sidebar';
import Header from '../components/header';
const Adminlayout = ({ children }) => {
    return (
        <>
            <div class="wrapper">
                <Sidebar/>
                <div class="main-panel">
                <Header/>
                        <div class="container">
                            <div class="page-inner">
                                {children}
                            </div>
                        </div>
                </div>
            </div>
        </>
    );
}

export default Adminlayout;